import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import Layout from './components/Layout';
import Members from './pages/Members';
import MemberDetail from './pages/MemberDetail';
import MemberNew from './pages/MemberNew';
import Reports from './pages/Reports';
import Users from './pages/Users';
import './index.css';

function LoadingScreen() {
  return (
    <div className="min-h-dvh flex items-center justify-center bg-surface">
      <p className="text-zinc-500 text-sm animate-pulse">Loading…</p>
    </div>
  );
}

function AppShell() {
  return (
    <Layout>
      <Routes>
        <Route path="/members" element={<Members />} />
        <Route path="/members/new" element={<MemberNew />} />
        <Route path="/members/:coId" element={<MemberDetail />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/users" element={<Users />} />
        <Route path="*" element={<Navigate to="/members" replace />} />
      </Routes>
    </Layout>
  );
}

function AuthGate() {
  const { isAuthenticated, isLoading } = useAuth();
  if (isLoading) return <LoadingScreen />;
  if (!isAuthenticated) return <Login />;
  return <AppShell />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AuthGate />
      </AuthProvider>
    </BrowserRouter>
  );
}
